function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from "react";
import { Button } from "react-bootstrap";
import FontAwesome from "react-fontawesome";

var DeleteRowRenderer = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(DeleteRowRenderer, _React$Component);

  function DeleteRowRenderer() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;

    _defineProperty(_assertThisInitialized(_this), "handleClick", function (event) {
      if (_this.props.confirmRemove && !window.confirm("Are you sure?")) return false;
      var onClick = _this.props.onClick;
      onClick && onClick(event, _this.props.rowIndex);
    });

    return _this;
  }

  var _proto = DeleteRowRenderer.prototype;

  _proto.render = function render() {
    return /*#__PURE__*/React.createElement(Button, {
      size: "sm",
      onClick: this.handleClick,
      variant: "link"
    }, /*#__PURE__*/React.createElement(FontAwesome, {
      className: "d-print-none",
      name: "times-circle",
      color: "#000000"
    }));
  };

  return DeleteRowRenderer;
}(React.Component);

export default DeleteRowRenderer;